import { makeTranslator } from '@/libraries/i18n'

const translations = {
  fi: {
    emptyDocument: 'Tyhjä asiakirja',
    toolbar: {
      undo: 'Kumoa',
      redo: 'Tee uudestaan',
      bold: 'Lihavointi',
      italic: 'Kursivointi',
      underline: 'Alleviivaus',
      strikethrough: 'Yliviivaus',
      blocktype: 'Muotoilu',
      h1: 'Otsikko 1',
      h2: 'Otsikko 2',
      h3: 'Otsikko 3',
      h4: 'Otsikko 4',
      h5: 'Otsikko 5',
      h6: 'Otsikko 6',
      paragraph: 'Leipäteksti',
      bulletList: 'Luettelo',
      numberedList: 'Numeroitu lista',
      checkboxList: 'Tehtävälista',
      leftAlign: 'Tasaus vasemmalle',
      centerAlign: 'Keskitä',
      rightAlign: 'Tasaus oikealle',
      justifyAlign: 'Tasaus molempiin reunoihin',
      insertTwoColumnLayout: 'Lisää kaksipalstainen asettelu',
    },
    image: {
      insertImage: 'Lisää kuva',
      imageProperties: 'Kuva',
      edit: 'Muokkaa',
      remove: 'Poista',
      url: 'URL-osoite',
      urlPlaceholder: 'Kuvan URL-osoite (https://…)',
      altText: 'Alt-teksti',
      width: 'Leveys',
      insertFromUrl: 'Lisää URL-osoitteesta',
      or: 'tai',
      uploadFile: 'Lataa tiedosto',
      uploading: 'Ladataan…',
      ok: 'OK',
      cancel: 'Peruuta',
    },
    link: {
      insertLink: 'Lisää linkki',
      linkOptions: 'Linkin asetukset',
      url: 'URL',
      remove: 'Poista linkki',
    },
    qrCode: {
      QRCode: 'QR-koodi',
      insertQRCode: 'Lisää QR-koodi',
      url: 'Koodin osoite tai teksti',
      title: 'Otsikko (valinnainen)',
      size: 'Koko',
      remove: 'Poista QR-koodi',
    },
    table: {
      insertTable: 'Lisää taulukko',
      removeTable: 'Poista taulukko',
      insertRow: 'Lisää rivi',
      deleteRow: 'Poista rivi',
      insertColumn: 'Lisää sarake',
      deleteColumn: 'Poista sarake',
      deleteTable: 'Poista taulukko',
      cols: 'Sarakkeet',
      rows: 'Rivit',
      cancel: 'Peruuta',
    },
    diagram: {
      insertDiagram: 'Lisää kaavio',
    },
    alignSelector: {
      align: 'Tasaus',
      left: 'Vasen',
      center: 'Keski',
      right: 'Oikea',
      fullWidth: 'Koko leveys',
      floatLeft: 'Kellu vasemmalla',
      floatRight: 'Kellu oikealla',
    },
  },
}

export const { useT: useEditorT, useTranslation: useEditorTranslation } = makeTranslator(translations)
